import { type FC } from 'react';

import css from './styles.module.scss';

const SpinnerDots: FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <rect
        className={`${css.rect} ${css.top}`}
        x="22"
        width="4"
        height="12"
        rx="2"
      />
      <rect
        className={`${css.rect} ${css.bottom}`}
        x="22"
        y="36"
        width="4"
        height="12"
        rx="2"
      />
      <rect
        className={`${css.rect} ${css.left}`}
        y="26"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-90 0 26)"
      />
      <rect
        className={`${css.rect} ${css.right}`}
        x="36"
        y="26"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-90 36 26)"
      />
      <rect
        className={`${css.rect} ${css.topLeft}`}
        x="5.61523"
        y="8.4436"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-45 5.61523 8.4436)"
      />
      <rect
        className={`${css.rect} ${css.bottomRight}`}
        x="31.071"
        y="33.8995"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-45 31.071 33.8995)"
      />
      <rect
        className={`${css.rect} ${css.bottomLeft}`}
        x="8.4436"
        y="42.3848"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-135 8.4436 42.3848)"
      />
      <rect
        className={`${css.rect} ${css.topRight}`}
        x="33.8994"
        y="16.9288"
        width="4"
        height="12"
        rx="2"
        transform="rotate(-135 33.8994 16.9288)"
      />
    </svg>
  );
};

export { SpinnerDots };
